import { Link } from "react-router-dom";

const BlogsGrid = ({ blogs }) => {
  return (
    <section className="py-20 bg-white">
      <div className="container-custom">

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="bg-white rounded-3xl overflow-hidden shadow-lg border border-gray-100"
            >

              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-64 object-cover"
              />

              <div className="p-6">

                <span className="text-[#F59E0B] text-sm font-semibold">
                  {blog.category}
                </span>

                <h3 className="text-xl font-bold text-[#082B57] mt-3">
                  {blog.title}
                </h3>

                <p className="text-gray-600 mt-4">
                  {blog.excerpt}
                </p>

                <Link
                  to={`/blogs/${blog.slug}`}
                  className="inline-block mt-6 text-[#F59E0B] font-semibold"
                >
                  Read More →
                </Link>

              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default BlogsGrid;